module.exports = __webpack_public_path__ + "img/personal-feed.0eb90fd9.svg";